module.exports = __webpack_public_path__ + "static/img/Jesse-Hogan.15f2f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-Hogan.jpg
// module id = 9aYW
// module chunks = 0